export const INFEASIBLE_RUN_STATUS = 'FAILURE (INFEASIBLE)';

export type ConstraintDiagnosticsTarget = {
  company: string;
  kpi: string;
  runId: string;
  status: string;
} & ({ type: 'linear' } | { type: 'streaming'; streamingType: string });

export const ConstraintDiagnosticsStatus = {
  LOADING: 'loading',
  VIOLATIONS_FOUND: 'violations_found',
  NOT_EXPLAINED: 'not_explained',
  NOT_AVAILABLE: 'not_available',
  UNAVAILABLE: 'unavailable'
} as const;
export type ConstraintDiagnosticsStatusType =
  (typeof ConstraintDiagnosticsStatus)[keyof typeof ConstraintDiagnosticsStatus];

export const ConstraintCategory = {
  BUDGET: 'budget',
  SPOT: 'spot',
  AUDIENCE: 'audience',
  GLOBAL: 'global',
  OTHER: 'other'
} as const;
export type ConstraintCategoryType = (typeof ConstraintCategory)[keyof typeof ConstraintCategory];

export const ConstraintBound = {
  MINIMUM: 'minimum',
  MAXIMUM: 'maximum'
} as const;

export interface ConstraintViolation {
  matrixRow: number;
  category: ConstraintCategoryType;
  name: string;
  networks: string[];
  bound: (typeof ConstraintBound)[keyof typeof ConstraintBound];
  limit: number;
  actual: number;
  difference: number;
}

export interface ConstraintDiagnostics {
  status: Exclude<ConstraintDiagnosticsStatusType, typeof ConstraintDiagnosticsStatus.LOADING>;
  violationCount: number;
  violations: ConstraintViolation[];
}

export const CONSTRAINT_CATEGORY_LABELS: Record<ConstraintCategoryType, string> = {
  budget: 'Budget',
  spot: 'Spot',
  audience: 'Audience',
  global: 'Global',
  other: 'Other'
};

export const CONSTRAINT_DIAGNOSTICS_MESSAGES = {
  loading: 'Loading rule details for this run…',
  not_explained:
    'The optimizer could not produce a valid plan, and the saved details do not show which rules were missed. The logs below may help explain why.',
  not_available: 'No rule details were saved for this run. The logs below may have more detail.',
  unavailable:
    'We couldn’t load rule details for this run. Try opening these details again, or use the logs below.'
} as const;
